import { EnrollmentStatus } from '@/pipeline/stateMachine';

export interface Course {
  id?: number;
  name?: string;
  descomplicaProviderCode?: string;
  descomplicaCurriculumId?: string;
}

export interface Campus {
  id?: number;
  name?: string;
  city?: string;
  state?: string;
}

export interface EnrollmentState {
  enrollmentId?: number;
  areDocumentsSent?: boolean;
  enrollmentStatus?: EnrollmentStatus;
  partnerCode?: string;
  /**
   * O cupom veio de fora, não foi digitado pelo aluno: do link pessoal do ProUni
   * (`/?cupom=`) ou do JWT do parceiro (cookie `d-partner`). Nesse caso o campo em
   * Dados Pessoais fica travado: trocá-lo desfaz o desconto e não existe caminho
   * de reaplicar cupom depois da matrícula criada no ERP.
   */
  isPartnerCodeLocked?: boolean;
  /**
   * `admissionType.evaluationMethod` da admissão (`getAdmission`). É o que diz se a
   * matrícula é ProUni (`'prouni'`), porque o cupom ProUni é o código real do JACAD,
   * sem prefixo. Vem do backend, então sobrevive a reload. `undefined` = ainda não
   * carregou (ou a query falhou): quem decide algo irreversível trata como incerto.
   */
  admissionEvaluationMethod?: string;
  /**
   * A troca `exchangeProuniEnrollmentToken` deu certo nesta aba. Cobre a sessão do
   * link antes de a admissão carregar; não sobrevive a reload — aí vale o campo acima.
   */
  isProuniEnrollmentLink?: boolean;
  course?: Course;
  campus?: Campus;
  hasErrorVoucher?: boolean;
  isComplementaryModuleEnabled?: boolean;
  backofficeStudentAcademicRecord?: string;
}

const enrollment: EnrollmentState = {
  enrollmentId: undefined,
  areDocumentsSent: undefined,
  enrollmentStatus: undefined,
  partnerCode: undefined,
  isPartnerCodeLocked: false,
  admissionEvaluationMethod: undefined,
  isProuniEnrollmentLink: false,
  course: undefined,
  campus: undefined,
  hasErrorVoucher: undefined,
  isComplementaryModuleEnabled: undefined,
  backofficeStudentAcademicRecord: undefined,
};

export default enrollment;
